<template>
  <div>
    <div class="screenshot">
      <el-upload
        class="avatar-uploader"
        action="https://192.168.1.229:81/hcm/hcmWorkOrder/headImgUpload/"
        :show-file-list="false"
        name="file"
        :http-request="picRequest"
        multiple
        :before-upload="beforeAvatarUpload"
        accept=".jpg, .png, .JPG"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        <div>上传</div>
      </el-upload>
      <div v-for="(item,index) in showUploadPicHtpp" :key="index" v-loading="loading[index]">
        <img :src="item" alt class="screenshot_pic" />
        <i class="el-icon-error" @click="deletePic(index)"></i>
      </div>
    </div>
    <div class='screenshot_tip'>支持上传9张截图，图片格式PNG，JPG、单张图片大小20M以内。</div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "uploadPic",
  data: function() {
    return {
      imageUrl: "",
      uploadPicHtpp: [],
      beformuploadPicHtpp: [],
      picIndex: 0,
      loading: [], //加载动画
      lodingIndex: [] ,//图片上传保存在uploadPicHtpp中的下标
      showUploadPicHtpp:[]
    };
  },
  props: {
    imgList: {
      default: () => {
        return [];
      }
    }
  },
  // 编辑初始化
  created() {
    this.uploadPicHtpp = this.imgList;
    this.picIndex = this.imgList.length;
    for (let i = 0; i < this.imgList.length; i++) {
      this.lodingIndex.push(i);
      this.loading.push(false);
      this.beformuploadPicHtpp.push(1);
    }
  },
  methods: {
    picRequest(a) {
      //图片上传
      if (this.beformuploadPicHtpp.length >= 9) {
        this.$message({ type: "warning", message: "最多只能上传9张截图" });
        return false;
      }
      this.picIndex = this.picIndex + 1;
      let thisIndex = this.picIndex - 1;
      this.lodingIndex[thisIndex] = thisIndex;
      this.beformuploadPicHtpp.push(1); //本地用来判断上传的图片数量
      let that = this;
      var formdata = new FormData();
      formdata.append("file", a.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const instance = axios.create({
        withCredentials: true,
        timeout: 60 * 5000
      });
      that.$set(that.showUploadPicHtpp, this.lodingIndex[thisIndex], "");//用来展示图片加载
      that.$set(that.loading, this.lodingIndex[thisIndex], true);
        console.log(this.beformuploadPicHtpp)
      instance
        .post("hcm/hcmWorkOrder/headImgUpload", formdata, config)
        .then(function(res) {
          let { data } = res;
          that.imgUrl = data.data.data;
           that.$set(that.uploadPicHtpp, that.lodingIndex[thisIndex],that.imgUrl);//最终图片
           that.$set(that.showUploadPicHtpp,that.lodingIndex[thisIndex],that.imgUrl);
          // that.$set(
          //   that.uploadPicHtpp,
          //   that.lodingIndex[thisIndex],
          //   that.imgUrl
          // );
          that.$set(that.loading, that.lodingIndex[thisIndex], false);
          that.$emit("getpic", that.uploadPicHtpp.join(","));
        });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("单张图片大小不能超过20M!");
        return false;
      }
    },
    deletePic(index) {
      //图片删除
      if (this.picIndex > 0) this.picIndex = this.picIndex - 1;
      this.uploadPicHtpp.splice(index, 1);
      this.showUploadPicHtpp.splice(index, 1);
      this.beformuploadPicHtpp.splice(index, 1);
      for (let i in this.lodingIndex) {
        if (i >= index) {
          this.lodingIndex[i] = this.lodingIndex[i] - 1;
        }
      }
      for (let j in this.uploadPicHtpp) {
        if (j >= index) {
          if (this.uploadPicHtpp[j] == "") this.loading[j] = true;
        }
      }
      let a;
      if (this.uploadPicHtpp.length > 0) a = this.uploadPicHtpp.join(",");
      else a = "";
      this.$emit("getpic", a);
    }
  }
};
</script>

<style lang="scss">
.screenshot_tip{
    font-size: 12px;
    color: #999999;
    line-height: 20px;
}
.screenshot {
  display: flex;
  flex-wrap: wrap;
  width: 77%;
  color: #666666;
  .avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 105px;
    height: 105px;
  }
  .avatar-uploader {
    background: #f7f8f8;
    border: 1px dashed #b5b5b5;
  }
  .uploading_pic_icon {
    width: 105px;
    height: 105px;
  }
  & > div {
    width: 105px;
    height: 105px;
    border-radius: 6px;
    margin-right: 20px;
    position: relative;
    text-align: center;
    margin-bottom: 5px;
  }

  .add_photo {
    border: 1px dashed #b5b5b5;
    text-align: center;
  }
  .el-icon-plus {
    color: #bfbfbf;
    font-size: 40px;
    margin-top: 25px;
  }
  .screenshot_pic {
    width: 100%;
    height: 100%;
  }
  .el-icon-error {
    font-size: 24px;
    color: #d81e06;
    position: absolute;
    top: -4px;
    right: -3px;
  }
}
</style>
